import styled from 'styled-components/macro'
import { DefaultParagraphLargeFactory } from '../core/Typograph/Typograph.Style'

export const DefaultSpan = styled.span(({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme })
}))

export const OrangeSpan = styled.span(({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme }),
    color: theme.color.brandSecondary.light,
    fontWeight: 600
}))